// extracted by mini-css-extract-plugin
module.exports = {"link":"Workflow_link__Rz80P"};